import React, {useState, useEffect, useContext, useCallback, useMemo, useRef} from "react"
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


//import { useForm, useWatch, reset} from "react-hook-form";
import { toast, ToastContainer } from "react-toastify"

import { Button } from "../components/ui"
import TablaInicioContainer from "../components/TablaInicioContainer"//para Obras mantener en desarrollo
import RedInicioContainer from "../components/RedInicioContainer"//para Redes
//import EditExp from "../components/editExp";
import NuevaEditRED from "../components/NuevaEditRED";
import TelegramModal from "../components/TelegramModal";
import TelegramChat from "../components/TelegramChat";

import { AuthContext } from "../context/authContext";
import {useEstadoApp} from "../context/EstadoAppContext";
import {initiateSocketConnection} from "../service/socketio";
import PreviewAndDownloadPDFReport from "../components/previewAndDownloadPDFReport";

import PreviewPDF from "../components/PreviewPDF"; //Informe Tecnico Obs
import { useGeo } from "../context/GeoContext";
import { useFormContext } from "../context/FormContext";

import {useRedContext} from "../context/RedContext";
import ResumenEntidad from '../components/ResumenEntidad'

import { useLocalStorage } from "../hooks/useLocalStorage";
import { useEntidadTokenAuth } from "../hooks/useEntidadTokenAuth";

import { REGISTROS_INICIAL } from "../utils/initialStates";
import { TRAMITACIONES_INTERNAS_INICIAL } from "../utils/initialStates";
import { TRAMITACIONES_EXTERNAS_INICIAL } from "../utils/initialStates";
import { SELECTED_REQUISITOS_INICIAL } from "../utils/initialStates";
import { PAGO_MEJORAS_INICIAL } from "../utils/initialStates";
import { PAGO_MICROCREDITOS_INICIAL } from "../utils/initialStates";
import { PAGO_PROYECTOS_INICIAL } from "../utils/initialStates";

const EVENT_NAME = 'redisKeyDeleted';

// Fuera del componente, al inicio del archivo
/*const TRAMITACIONES_EXTERNAS_INICIAL = [{
    exp: '',
    fecha_salida_convenio: null,
    fecha_firma_convenio: null,
    fecha_salida_reso: null,
    fecha_firma_reso: null
}];
*/

const InicioPageComponente = () => {
    const location = useLocation();
    console.log("REnderizado Memo")

    const navigate = useNavigate();
    const { setItem, removeItem, getItem } = useLocalStorage();

    // Estado para detectar si hay borrador en localStorage
    const [hasDraftData, setHasDraftData] = useState(false);    
    
    // Ref para evitar ejecución múltiple del useEffect de editor_entidad
    const editorEntidadLoadedRef = useRef(false);
    
    // Ref para rastrear si el usuario ocultó el indicador de borrador
    const draftIndicatorDismissedRef = useRef(false);
    
    // Estado de carga para editor_entidad
    const [isLoadingEntidad, setIsLoadingEntidad] = useState(false);

    // Estado para modo edición por token de entidad (registro desde email)
    const [isEntidadTokenMode, setIsEntidadTokenMode] = useState(false);
    const { isEntidadAuthenticated, entidadIdRed, entidadSession, loginEntidad } = useEntidadTokenAuth();

    /* inicia States*/
    const {user, userId, role, userMunicipio, entidadId, isAuthenticated, token, isEspecial} = useContext(AuthContext)

    const {formData, updateSection, clearPersistedData} = useRedContext();

    // ** ESTADO PRINCIPAL: Maquina de Estados **
    const { estadoAppX, cambiarEstadoApp, origenNavegacion, setOrigenNavegacion } = useEstadoApp(); // Usamos nuestro custom hook
    //estado temporal para manejar desde donde viene el estado
    const [deDondeViene, cambiarDeDondeViene] = useState(""); //24-JUL-2025


    // Detectar si hay datos en formData (del contexto/LocalStorage)
    useEffect(() => {
        // Verificar si al menos una sección tiene alguna propiedad
        const sections = ['identidad', 'legalSocial', 'predio', 'infra', 'vidaDeportiva', 'diagnostico'];
        const hasAnyData = sections.some(section => {
            const sectionData = formData[section];
            return sectionData && Object.keys(sectionData).length > 0;
        });
        
        // Debug: Mostrar estado del formulario
        console.log('📊 formData check:', {
            identidad: formData.identidad ? Object.keys(formData.identidad).length : 0,
            legalSocial: formData.legalSocial ? Object.keys(formData.legalSocial).length : 0,
            predio: formData.predio ? Object.keys(formData.predio).length : 0,
            hasAnyData,
            role,
            estadoAppX
        });
        
        // No mostrar indicador si el usuario lo ocultó explícitamente
        if (draftIndicatorDismissedRef.current) {
            console.log("📭 Indicador ocultado por usuario, no se muestra");
            return;
        }
        
        // No mostrar indicador si el usuario descartó el borrador previamente (persiste entre recargas)
        const dismissedEntityId = localStorage.getItem('red_form_draft_dismissed');
        if (dismissedEntityId && (dismissedEntityId === entidadId || dismissedEntityId === 'true')) {
            console.log("📭 Borrador descartado previamente, no se muestra indicador");
            setHasDraftData(false);
            return;
        }
        
        if (hasAnyData) {
            console.log("✅ Hay datos en progreso en formData");
            setHasDraftData(true);
        } else {
            console.log("📭 Todas las secciones de formData están vacías");
            setHasDraftData(false);
        }
    }, [formData, role, estadoAppX, entidadId]); // Se ejecuta cuando formData cambia

    // Limpiar la bandera de descarte al hacer logout
    useEffect(() => {
        const handleLogout = () => {
            localStorage.removeItem('red_form_draft_dismissed');
        };
        
        window.addEventListener('red-logout', handleLogout);
        return () => window.removeEventListener('red-logout', handleLogout);
    }, []);

    // Modo edición    // Efecto para resetear el ref al hacer logout
    useEffect(() => {
        const handleLogout = () => {
            editorEntidadLoadedRef.current = false;
            console.log('🔄 Ref reseteado por logout');
        };
        
        window.addEventListener('red-logout', handleLogout);
        return () => window.removeEventListener('red-logout', handleLogout);
    }, []);

    // Efecto para establecer estado inicial según el rol al montar (recargar página)
    // - editor_entidad va directamente a 'ediT'
    // - Todos los demás roles van a 'inicial'
    // Se ejecuta cuando role o isAuthenticated cambian (esperar a que auth esté listo)
    useEffect(() => {
        if (!isAuthenticated || !role) return; // Esperar a que auth esté listo
        
        if (role === 'editor_entidad') {
            console.log('🔄 Editor entidad: forzando estado ediT al montar');
            cambiarEstadoApp('ediT');
        } else {
            console.log('🔄 Usuario normal: forzando estado inicial al montar');
            cambiarEstadoApp('inicial');
        }
    }, [role, isAuthenticated]); // Ejecutar cuando role esté disponible

    // Efecto para resetear el ref cuando se vuelve a ediT desde el resumen (ver)
    useEffect(() => {
        if (estadoAppX === 'ediT' && role === 'editor_entidad') {
            // Si venimos de 'ver' o es la primera vez, resetear el ref para permitir recarga
            editorEntidadLoadedRef.current = false;
            console.log('🔄 Ref reseteado por cambio a ediT');
        }
    }, [estadoAppX, role]);

    // Modo edición automático para editor_entidad al iniciar sesión
    useEffect(() => {
        // Prevenir ejecución múltiple
        if (editorEntidadLoadedRef.current) return;
        
        // Si es editor_entidad, tiene entidadId y está autenticado, entrar en modo edición
        // PERO: respetar estado 'ver' si el usuario está viendo el resumen
        // NOTA: No verificamos estadoAppX === 'inicial' porque puede venir de localStorage de otra sesión
        if (role === 'editor_entidad' && entidadId && isAuthenticated && estadoAppX !== 'ver') {
            editorEntidadLoadedRef.current = true; // Marcar como cargado
            
            // Verificar si hay borrador en localStorage (red_form_draft) - si existe, verificar que sea del mismo entidadId
            // Primero verificar directamente en localStorage
            const rawStorage = localStorage.getItem('red_form_draft');
            let hasDraftInLS = false;
            let lsBelongsToCurrentEntity = false;
            if (rawStorage) {
                try {
                    const parsed = JSON.parse(rawStorage);
                    const sections = ['identidad', 'legalSocial', 'predio', 'infra', 'vidaDeportiva', 'diagnostico'];
                    hasDraftInLS = sections.some(section => {
                        const sectionData = parsed[section];
                        return sectionData && Object.keys(sectionData).length > 0;
                    });
                    // Verificar si el borrador pertenece al entidadId actual
                    const lsEntidadId = parsed.identidad?.id_red;
                    lsBelongsToCurrentEntity = lsEntidadId === entidadId;
                    console.log('📦 localStorage check (red_form_draft) - entidadId en LS:', lsEntidadId, 'entidadId actual:', entidadId, 'match:', lsBelongsToCurrentEntity);
                } catch (e) {
                    console.error('Error parsing localStorage:', e);
                }
            }
            
            // También verificar en formData (del contexto) - que pertenezca al entidadId actual
            const sections = ['identidad', 'legalSocial', 'predio', 'infra', 'vidaDeportiva', 'diagnostico'];
            const hasDraftDataInForm = sections.some(section => {
                const sectionData = formData[section];
                return sectionData && Object.keys(sectionData).length > 0;
            });
            const formEntidadId = formData.identidad?.id_red;
            const formBelongsToCurrentEntity = formEntidadId === entidadId;
            
            console.log('🔍 Editor entidad check - localStorage:', hasDraftInLS, 'match:', lsBelongsToCurrentEntity, 'formData:', hasDraftDataInForm, 'formMatch:', formBelongsToCurrentEntity);
            
            // Para editor_entidad: si hay borrador propio, mostrar indicador pero NO cargarlo automáticamente
            // El usuario debe hacer clic en "Continuar carga" para recuperar el borrador
            if (!draftIndicatorDismissedRef.current && ((hasDraftInLS && lsBelongsToCurrentEntity) || (hasDraftDataInForm && formBelongsToCurrentEntity))) {
                console.log('📝 Editor de entidad tiene borrador propio - mostrando indicador, cargando del servidor');
                setHasDraftData(true); // Mostrar indicador de borrador
                // NO retornamos aquí - continuamos para cargar desde el servidor
            }
            
            // Si hay datos de OTRA entidad en localStorage/formData, limpiarlos
            if ((hasDraftInLS && !lsBelongsToCurrentEntity) || (hasDraftDataInForm && !formBelongsToCurrentEntity)) {
                console.log('⚠️ Datos de otra entidad detectados, limpiando localStorage y formData');
                clearPersistedData();
            }
            
            console.log('🎯 Editor de entidad detectado, cargando entidad desde servidor:', entidadId);
            
            // Verificar si hay borrador válido que pertenezca a esta entidad
            // rawStorage ya fue declarado arriba
            let currentDraft = null;
            let shouldRestoreDraft = false;
            
            if (rawStorage && lsBelongsToCurrentEntity) {
                currentDraft = rawStorage;
                shouldRestoreDraft = true;
                console.log('💾 Borrador guardado para restauración después del servidor');
            }
            
            const loadEntidadForEditor = async () => {
                try {
                    const response = await fetch(`/api/entidades/datos_entidad/${entidadId}`);
                    if (response.ok) {
                        const data = await response.json();
                        console.log('✅ Datos de entidad cargados:', data);
                        
                        // Cargar todas las secciones del formulario
                        // El backend devuelve un objeto con secciones: { identidad: {...}, sede: {...}, ... }
                        if (data) {
                            Object.keys(data).forEach(section => {
                                if (data[section] && typeof data[section] === 'object') {
                                    updateSection(section, data[section], true); // isServerLoad = true
                                }
                            });
                        }
                        
                        // Cambiar a modo edición primero
                        cambiarEstadoApp('ediT');
                        
                        // Si no hay borrador del usuario que restaurar, los datos del servidor
                        // son la fuente de verdad — marcar como "limpio" para que el banner
                        // de "Recuperar" no aparezca en la primera carga ni en recargas sin ediciones.
                        // La bandera se limpia automáticamente cuando el usuario hace una edición
                        // (updateSection sin isServerLoad).
                        if (!shouldRestoreDraft) {
                            localStorage.setItem('red_form_draft_dismissed', entidadId);

                        }
                        
                        // Restaurar el borrador en localStorage después de un delay
                        // para asegurar que se ejecute DESPUÉS de los efectos de persistencia
                        if (shouldRestoreDraft && currentDraft) {
                            setTimeout(() => {
                                console.log('📝 Restaurando borrador en localStorage después de cargar del servidor');
                                localStorage.setItem('red_form_draft', currentDraft);
                            }, 100);
                        }
                    } else {
                        console.error('❌ Error al cargar entidad:', response.statusText);
                    }
                } catch (error) {
                    console.error('❌ Error fetching entidad:', error);
                }
            };
            
            loadEntidadForEditor();
        }
    }, [role, entidadId, estadoAppX, cambiarEstadoApp, updateSection, isAuthenticated]);

    const {identidad} = formData;
    const {id_red} = identidad;

    const {resetForm, updateField, updateFormData, updateFormB, updateFormC, formA, formB, formC} = useFormContext();

    const { datosGenerales, tipoSubtipoProyecto, array_obras_expediente } = formA;
    const { selectedRequisitos, tramitacionesExternas, tramitacion, observaciones } = formB;
    const {reporteEntidad, internas, tramitacionExterna} = observaciones;
    const {seguimientoObra, arrayPagosMejoras, arrayPagosMicrocreditos, arrayPagosProyectos} = formC;
    const {
        encargadoRendicion, 
        montoObra, 
        organismoEncargado, 
        empresaContratista, 
        fechaInicioObra, 
        fechaFinObra, 
        observaciones: observacionesSeguimientoObra 
        //arrayPagosMejoras, 
        //arrayPagosMicrocreditos, 
        //arrayPagosProyectos
    } = seguimientoObra;    

    //console.log("user ---->", user)
    //console.log("userId ---->", userId)
    const { clearFeatures, loadFeaturesForObra, drawnFeatures } = useGeo();
    //console.log("drawnFeatures ---->", drawnFeatures)
    //prueba 5.jul.2025


    //RED************
    const [dataRED, setDataRED] = useState([])
    console.log("dataRED ---->", dataRED)

    const [key, setKey] = useState(null); //17oct2025: para claves eliminadas

    const [new_EditandoId, setNewEditandoId] = useState(""); //---> cambia cuando se de dobleclick en simpleTable (comienza edicion)    
    //console.log("A- para Socket: new_EditandoId ---->", new_EditandoId)
    // 27FEB25 - Estado para almacenar el formulario consultado por ID
    const [registrosEditados, setRegistrosEditados] = useState({}); // { 'ID': 'user_ID' }
    //console.log("registrosEditados ---->", registrosEditados)

    const [formularioConsultado, setFormularioConsultado] = useState(null);
    console.log("VERIFICAR formularioConsultado ---->", formularioConsultado)
    
    //9JUL25 - Estado para almacenar las geometrías de la obra
    const [geometries, setGeometries] = useState([]);

    const [busquedaUsuarios, setBusquedaUsuarios] = useState([]);
    //console.log("Usuarios editando el mismo ID", busquedaUsuarios)

    const [arrayEditando, setArrayEditando] = useState([]);
    console.log("CONSULTANDO arrayEditando ---->", arrayEditando)
    /*
    NOTA: se usa cuando se loguea un usuario verificar si hay registros en edicion por otros usuarios.
    el endpoint arrayEditando verifica desde nodejs a redis si hay registros en edicion por otros usuarios.
    luego se actualiza el arrayEditando con los datos de redis.
    */
    console.log("B- para Socket: arrayEditando ---->", arrayEditando)   

    const [loading, setLoading] = useState(true);
    
    //24JUL25
    //const [guardarEstados, setGuardarEstados] = useState(false) #5dic25 - se va
    
    const [valorX, setValorX] = useState("")

    //const [dataSubformTipo, setDataSubformTipo] = useState([]) 
    //console.log("OSO dataSubformTipo ---->", dataSubformTipo)
    //const dataSubformTipoRef = useRef(dataSubformTipo); // ----> NO USAR POR AHORA #26FEB25

    //NUEVO **** 25JUL2025 usar este estado
    const [dataSubformulario, setDataSubformulario] = useState([])

    const [data, setData] = useState([])
    //console.log("DATA de OBRAS, cargar al entrar ---->>",data)

    const [nueva_obra, setNuevaObra] = useState(false)

    const [socket, setSocket] = useState(null);
    //console.log("SOCKET en client", socket)
    const [isSocketConnected, setIsSocketConnected] = useState(false);
    const socketRef = useRef(null);
    const [pendingUpdates, setPendingUpdates] = useState(false);
    const [lastUpdateInfo, setLastUpdateInfo] = useState(null);
    
    const renderCount = useRef(0);
    const isInitialMount = useRef(true);  //5-agos-2025: estado local, solo para garantizar que modalidad no se resetee en la carga inicial

    const [modoEdicion, setModoEdicion] = useState("manual")
    //console.log("MODO EDICION", modoEdicion)
    
    const [formularioEsValido, setFormularioEsValido] = useState(false); //15oct2025: 1. Estado para almacenar la validez del formulario hijo
    console.log("VER formularioEsValido ---->", formularioEsValido)

    const [escuchandoLocalData, setEscuchandoLocalData] = useState({});
    console.log("escuchandoLocalData ---->", escuchandoLocalData);
    
    // Refs to store the data and table reference for the double-click simulation
    const tableInicioRef = useRef(null);
    const [dataForTable, setDataForTable] = useState([]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const [idPartidoObra_leido, setIdPartidoObra_leido] = useState("");  
    
    useEffect(() => { // RED: si cambia id_red hacer la llamada al resumen por id_red
        
        // Verificar si hay borrador en localStorage antes de llamar al servidor
        const rawStorage = localStorage.getItem('red_form_draft');
        let hasDraftInLS = false;
        if (rawStorage) {
            try {
                const parsed = JSON.parse(rawStorage);
                const sections = ['identidad', 'legalSocial', 'predio', 'infra', 'vidaDeportiva', 'diagnostico'];
                hasDraftInLS = sections.some(section => {
                    const sectionData = parsed[section];
                    return sectionData && Object.keys(sectionData).length > 0;
                });
                // Verificar que el borrador pertenezca al id_red actual
                const lsEntidadId = parsed.identidad?.id_red;
                if (lsEntidadId !== id_red && lsEntidadId !== entidadIdRed) {
                    hasDraftInLS = false; // El borrador es de otra entidad
                }
            } catch (e) {
                console.error('Error checking localStorage:', e);
            }
        }
        
        // Solo cargar desde backend cuando estamos en modo edición iniciado desde tabla
        // No recargar al iniciar la app desde localStorage (continuar edición)
        // O si hay un borrador válido en localStorage
        if (id_red !== null && id_red !== undefined && estadoAppX === 'ediT' && !hasDraftInLS) { 
            console.log("LLAMANDO id_red", id_red, "(no hay borrador en localStorage)");           
            getResumenPorIdRed(id_red);
        } else if (hasDraftInLS) {
            console.log("📋 Hay borrador en localStorage, no se llama al servidor");
        }
        
        // También cargar datos cuando estamos en modo edición por token de entidad
        // Pero solo si no hay borrador en localStorage
        if (isEntidadTokenMode && entidadIdRed && estadoAppX === 'ediT' && !hasDraftInLS) {
            console.log("LLAMANDO entidadIdRed modo token", entidadIdRed, "(no hay borrador)");
            getResumenPorIdRed(entidadIdRed);
        }
    }, [id_red, estadoAppX, isEntidadTokenMode, entidadIdRed]);

    //un useEffect cada vez que cambie estadoApp 
    /*
    useEffect(() => {
        //solo si es igual a edit_desde_pagos -----> leer desde localStorage
        if(estadoAppX === 'edit_desde_pagos' || estadoAppX === 'edit_desde_proyectos'){
            const idPartidoObra = localStorage.getItem('idPartidoObra');
            //const isEditing = localStorage.getItem('isEditing');
            const isEditingPagos = localStorage.getItem('isEditingPagos');
            const isEditingProyectos = localStorage.getItem('isEditingProyectos');
            
            if (idPartidoObra) {
                console.log('idPartidoObra encontrado:', idPartidoObra);
                // Aquí puedes hacer lo que necesites con el idPartidoObra
                setIdPartidoObra_leido(idPartidoObra);
                //Para enviar para Socket, para mostrar en tabla inicio que registro se esta editando
                setNewEditandoId(idPartidoObra)
                //setIsEditing(isEditing)
                setIsEditingPagos(isEditingPagos)
                setIsEditingProyectos(isEditingProyectos)
            } else {
                console.log('No se encontró idPartidoObra en el localStorage');
            }
        }
    }, []) //Al montar el componente, pero si estadoAppX es edit_desde_pagos
    */


    // Efecto para manejar la navegación desde TablaObras
    useEffect(() => {
        // Solo ejecutar si hay un idPartidoObra_leido
        if (!idPartidoObra_leido) return;

        console.log('🔍 Navegación detectada - id_partido_obra en estado:', idPartidoObra_leido);

        // Función para buscar y editar el registro
        const findAndEditRecord = () => {
            if (!dataForTable || dataForTable.length === 0) {
                console.log('⏳ dataForTable vacío, intentando de nuevo en 500ms...');
                //setTimeout(findAndEditRecord, 500); // Reintentar después de 500ms
                return;
            }

            console.log('🔎 Buscando registro con id_partido_obra:', idPartidoObra_leido);
            console.log('📋 IDs disponibles en dataForTable:', dataForTable.map(item => item.id_partido_obra));

            // Resto del código de la función findAndEditRecord...
            const matchingRecord = dataForTable.find(item => {
                const match = item.id_partido_obra === idPartidoObra_leido;
                console.log('Comparando:', item.id_partido_obra, 'con', idPartidoObra_leido, '->', match);
                return match;
            });

            if (matchingRecord) {
                // ... resto del código para manejar el registro encontrado ...
                handleEditarRegistro(matchingRecord);
            } else {
                console.warn('⚠️ No se encontró ningún registro con id_partido_obra:', idPartidoObra_leido);
                // ... resto del código para manejar cuando no se encuentra el registro ...
            }
        };

        // Llamar a la función
        findAndEditRecord();

        // Función de limpieza
        return () => {
            console.log('🧹 Limpiando efecto de navegación');
        };
    }, [idPartidoObra_leido, dataForTable]); // Se ejecuta cuando cambia idPartidoObra_leido o dataForTable

    // Inicializar conexión Socket.IO (una sola vez)
    useEffect(() => {
      const s = initiateSocketConnection();
      setSocket(s);
      socketRef.current = s;

      const onConnect = () => {
        console.log('[socket] connected', s.id);
        setIsSocketConnected(true);
      };
      const onDisconnect = () => {
        console.log('[socket] disconnected');
        setIsSocketConnected(false);
      };

      s.on('connect', onConnect);
      s.on('disconnect', onDisconnect);

      // 2. Escuchar el evento
        s.on(EVENT_NAME, (payload) => {
            console.log('Evento recibido:', payload);
            setKey(payload.key);
            //PRO AHORA NO---- >setMessage(`✅ ¡Clave "${payload.key}" eliminada! Notificación recibida a las ${new Date(payload.timestamp).toLocaleTimeString()}`);

            //No recarga las obras, solo chequea el array_editando
            consultar_array_editando();
            
        });

      return () => {
        s.off('connect', onConnect);
        s.off('disconnect', onDisconnect);
        s.off(EVENT_NAME);
        try { s.close(); } catch (e) {}
      };
    }, []);

    // Escuchar actualizaciones de obras desde el backend
    useEffect(() => {
      if (!socket) return;
      const handler = (payload) => {
        console.log('[socket] obras_changed received', payload);
        setLastUpdateInfo(payload);
        setPendingUpdates(true);
        const who = payload?.by_user ? ` por ${payload.by_user}` : '';
        const obra = payload?.nombre_obra ? ` en "${payload.nombre_obra}"` : '';
        const msgBase = payload?.type === 'created' ? 'Nuevo proyecto disponible' : 'Se modificó proyecto';
        toast.info(`${msgBase}${obra}${who}. Puedes actualizar cuando quieras.`);
      };
      socket.on('obras_changed', handler);
      return () => socket.off('obras_changed', handler);
    }, [socket]);

    const applyPendingUpdates = async () => {
      await getObras(true);
      setPendingUpdates(false);
      setLastUpdateInfo(null);
      toast.success('Datos actualizados');
    };

    useEffect(() => {
      renderCount.current++;
      console.log(`InicioPage RENDER ${renderCount.current}`, {
        registro,
        //estadoApp,
        modoEdicion
      });
    });

    const [bloquear, setBloquear] = useState(false)

    const [editandoInput, setEditandoInput]=useState({
        id_registro: null,
        id_input_editando : null
    });
    console.log("------>CUAL ES EL ID del Input que se está editando??", editandoInput )    
    
    //NOTA: 25-jul-2025: registro va a cambiar de estado cuando se seleccione una row en Simpletable
    // cada vez se haga una edicion.
    //cada vez que se cree una nueva obra  

    //ESTADOS principales
    const [registro, setRegistro] = useState(REGISTROS_INICIAL);
    console.log("REGISTRO --->", registro)
    console.log("nombre_obra en Registro a EDITAR", registro.nombre_obra)

    // Estados de carga para los botones de guardado
    const [isSavingExit, setIsSavingExit] = useState(false);
    const [isSavingCont, setIsSavingCont] = useState(false);

    //Nuevo estado para saber si se está editando un registro
    const [isEditing, setIsEditing] = useState(false);
    console.log("IS EDITING cambia desde TablaInicio", isEditing)

    const [isEditingPagos, setIsEditingPagos] = useState(false);
    console.log("IS EDITING cambia desde TablaPagos", isEditingPagos)
    const [isEditingProyectos, setIsEditingProyectos] = useState(false);
    console.log("IS EDITING cambia desde TablaProyectos", isEditingProyectos)
    

    const [tramitacionesInternas, setTramitacionesInternas] = useState(TRAMITACIONES_INTERNAS_INICIAL);
    console.log("<---------tramitacionesInternas--->", tramitacionesInternas)
    
    //ahora se obtiene desde el conxte. Que pasa con setTramitacionesExternas?
    //const [tramitacionesExternas, setTramitacionesExternas] = useState([TRAMITACIONES_EXTERNAS_INICIAL]);

    // Nuevos estados para los textareas:
    const [observacionesReporteEntidad, setObservacionesReporteEntidad] = useState("");
    const [observacionesInternas, setObservacionesInternas] = useState("");

    const [observacionesTramitacionExterna, setObservacionesTramitacionExterna] = useState("");      

    // Estados para Requisitos - 12-jun-2025
    //const [selectedRequisitos, setSelectedRequisitos] = useState(SELECTED_REQUISITOS_INICIAL); // USAR este!!!    
    //console.log("selectedRequisitos--->", selectedRequisitos)

    //CAMBIO 4-agos-2025: se quita estado resetRegistro
    //1-agos-2025: estado para formC**

    const [formularioSeguimientoObra, setFormularioSeguimientoObra] = useState(null); //2AGOS25

    const [encargado_rendicion, setEncargadoRendicion] = useState('');
    //const [monto_obraC, setMontoObraC] = useState(registro.monto_obra); // Asumiendo que registro está disponible
    //aceder desde el contexto
    const [monto_obraC, setMontoObraC] = useState(datosGenerales.monto_obra);
    const [organismo_encargado, setOrganismoEncargado] = useState('');
    const [empresa_contratista, setEmpresaContratista] = useState('');
    //estado para fecha_inicio_obra y fecha_fin_obra
    const [fecha_inicio_obra, setFechaInicioObra] = useState(null);
    const [fecha_fin_obra, setFechaFinObra] = useState(null);    

    //const [arrayPagosMejoras, setArrayPagosMejoras] = useState([PAGO_MEJORAS_INICIAL]);
    //const [arrayPagosMicrocreditos, setArrayPagosMicrocreditos] = useState([PAGO_MICROCREDITOS_INICIAL]);
    //const [arrayPagosProyectos, setArrayPagosProyectos] = useState([PAGO_PROYECTOS_INICIAL]);
    
    const [observ_seguimiento_obra, setObservSeguimientoObra] = useState('');
    
    // Importar el componente DownloadPDFButton
    const DownloadPDFButton = React.lazy(() => import('../components/DownloadPDFButton'));
    
    // Función para manejar el clic en el botón de ver informe 
    const handlePreviewClick = (obra) => {
        console.log("CLICK en obra", obra)
        //cambiarEstadoApp('previewInformeTecnicoObservaciones', obra); //previewInformeTecnico_PRUEBA
        cambiarEstadoApp('previewInformeTecnicoObservaciones', {obra: obra}); //previewInformeTecnico_PRUEBA
    }
    

    //const {array_obras_expediente} = registro
    //console.log("EL array de expedientes obras", array_obras_expediente)


    /*--- cierra States ---*/

    //** inicia FUNCIONES */    

    // Ahora la logica de de Validación se hace en inicio page #3dic2025  
    /*       
    useEffect(() => {        
        //desde el context
        const esEncargadoValido = String(datosGenerales.encargado_proyecto).trim() !== ''; 
        const esAreaValido = String(datosGenerales.area_responsable).trim() !== ''; 
        const esPartidoValido = String(datosGenerales.partido).trim() !== ''; 
        
        const camposObligatoriosLlenos = 
            datosGenerales.nombre_obra.trim() !== '' && 
            esEncargadoValido && 
            esAreaValido && 
            esPartidoValido; 
        
        setFormularioEsValido(camposObligatoriosLlenos);
        
    }, [datosGenerales.nombre_obra, datosGenerales.encargado_proyecto, datosGenerales.area_responsable, datosGenerales.partido]); // ¡Añadir 'partido' aquí!
    */

    const getResumenPorIdRed = async (id_red) => {
        console.log("ENtrando ACÄ getResumenPorIdRed", id_red)
        const url = `/api/entidades/datos_entidad/${id_red}`;
        const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }
        
        try {
            const response = await fetch(url, {headers});
            const result = await response.json();
            console.log("Datos recibidos en getResumenPorIdRed:", result);
            
            // El backend ahora devuelve estructura anidada: { identidad: {...}, legalSocial: {...}, ... }
            const data = Array.isArray(result) && result.length > 0 ? result[0] : result;
            
            // Actualizar cada sección del contexto con los datos correspondientes
            Object.keys(data).forEach(section => {
                updateSection(section, data[section], true);
            });
        } catch (error) {
            console.error('Error al buscar entidades:', error);
        } finally {
            setLoading(false);
        }            
    }
      
    
    const getRed = async () => {
        console.log("ENtrando ACÄ getRed")
        const url = `/api/entidades/lista_resumen`;
        const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }
        
        try {
            const response = await fetch(url, {headers});
            const result = await response.json();
            console.log("Datos recibidos en getRed:", result); // Verifica los datos
            setDataRED(result);
        } catch (error) {
            console.error('Error al buscar entidades:', error);
        } finally {
            setLoading(false);
        }            
    }

    const getObras = async (force = false) => {
        console.log("ENtrando ACÄ getObras", { force })

        const url = `/api/obras${force ? '?refresh=1' : ''}`;
        const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }
        
        try {
            const response = await fetch(url, {headers});
            const result = await response.json();
            console.log("Datos recibidos en getObras:", result); // Verifica los datos
            setData(result);
        } catch (error) {
            console.error('Error al buscar obras:', error);
        } finally {
            setLoading(false);
        }            
    }
    
    const consultar_array_editando = async () => {
        console.log("CONSULTANDO arrayEditando")
        const url = `/api/arrayEditando`;
        const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }

        try {
            const response = await fetch(url, {headers});
            const result = await response.json();
            console.log("Datos recibidos en getObras:", result); // Verifica los datos
            if(result){
                setArrayEditando(result);
            } else {
                console.log("No hay datos en arrayEditando")
                setArrayEditando([]);
            }
        } catch (error) {
            console.error('Error al buscar obras:', error);
        }        
    }

    // 15oct25 VERIFICAR (para socket.io)
    const quitarIdEdicion = (id) => {

        console.log("QUITAR este ID con Socket.io", id)

        if(socket){
            socket.emit("quitar_id_edicion", id, user)//pasar tambien el user
        }

    }

    const toggle = () => {
        if(estadoAppX === "inicial"){
            cambiarEstadoApp("nuevo"); //---usar context
            clearFeatures(); //borra las features del mapa

            clearPersistedData();
            setHasDraftData(false);
            
        } else if(estadoAppX === "nuevo" || estadoAppX === "ediT" || estadoAppX === "continuar_nuevo"){
            if(estadoAppX === "ediT"){
                quitarIdEdicion(datosGenerales.id_partido_obra)
                localStorage.removeItem('idPartidoObra');
            }            
            
            cambiarEstadoApp("inicial"); //---usar context            

            //limpiar de localStorage id_partido_obra
            localStorage.removeItem('idPartidoObra');
            //localStorage.removeItem('lastActiveTab');
            clearFeatures(); //borra las features del mapa
            setBloquear(false);

            clearPersistedData();
            setHasDraftData(false);
            

        } else if (estadoAppX === "edit_desde_pagos" || estadoAppX === "edit_desde_proyectos"){

            cambiarEstadoApp("inicial"); //---usar context

            if (origenNavegacion === "tramitaciones") {
                const tabOrigen = localStorage.getItem('lastActiveTab'); //location.state?.origen; // 'pagos' o 'proyectos'
                console.log('Navegando a /tramitaciones con tab:', tabOrigen);
                if (tabOrigen) { // Solo si hay un origen específico
                    console.log("TIENE tabOrigen")
                    navigate(`/tramitaciones`, {
                        //state: {
                        //    tabActivo: tabOrigen
                        //},----> usar origen desde locastorage: lastActiveTab
                        replace: true // Para no guardar en el historial
                    });
                } else {
                    console.log("NO TIENE tabOrigen")
                    // Si no hay origen específico, navegar sin forzar el tab
                    navigate(`/inicio`, { replace: true });
                }
            }
            clearFeatures(); //borra las features del mapa
            localStorage.removeItem('idPartidoObra');
            localStorage.removeItem('isEditingPagos');
            localStorage.removeItem('isEditingProyectos');
            setBloquear(false);
        }
    };

    // Función para continuar con el borrador existente
    // Verifica si es nuevo (id_red null) o edición (id_red con valor)
    const handleContinuarNuevo = () => {
        const rawStorage = localStorage.getItem('red_form_draft');
        let isNewEntity = true;
        
        if (rawStorage) {
            try {
                const parsed = JSON.parse(rawStorage);
                console.log('🔍 handleContinuarNuevo - parsed:', parsed);
                console.log('🔍 parsed.identidad:', parsed.identidad);
                
                const idRed = parsed.identidad?.id_red;
                const entidadId = parsed.identidad?.entidad_id;
                
                console.log('🔍 id_red:', idRed, 'tipo:', typeof idRed, 'truthy:', !!idRed);
                console.log('🔍 entidad_id:', entidadId, 'tipo:', typeof entidadId, 'truthy:', !!entidadId);
                
                // Si id_red o entidad_id tienen valor, es una edición existente
                if (idRed || entidadId) {
                    isNewEntity = false;
                    console.log('📋 Continuando edición de entidad existente - id_red:', idRed, 'entidad_id:', entidadId);
                } else {
                    console.log('📋 Continuando nuevo registro (sin id_red ni entidad_id)');
                }
                
                // Si ya estamos en ediT (caso editor_entidad), cargar datos del borrador al contexto
                if (estadoAppX === 'ediT') {
                    console.log('📝 Cargando datos del borrador al contexto...');
                    const sections = ['identidad', 'legalSocial', 'predio', 'infra', 'vidaDeportiva', 'diagnostico'];
                    sections.forEach(section => {
                        if (parsed[section] && typeof parsed[section] === 'object') {
                            updateSection(section, parsed[section]);
                        }
                    });
                    console.log('✅ Datos del borrador cargados al contexto');
                    return; // No cambiar de estado, ya estamos en ediT
                }
            } catch (e) {
                console.error('Error parsing localStorage:', e);
            }
        }
        
        console.log('🔍 isNewEntity:', isNewEntity, '→ estado:', isNewEntity ? 'continuar_nuevo' : 'ediT');
        cambiarEstadoApp(isNewEntity ? 'continuar_nuevo' : 'ediT');
    };

    //5-agos-205: resetear a valores iniciales
    useEffect(()=>{
        if(estadoAppX === "inicial"){
            console.log("LIMPIA newEditandoId")

            resetForm();

            localStorage.removeItem('idPartidoObra');

            setNewEditandoId(""); //si es "inicial" ---> limpiar el id editando
            setRegistrosEditados({});

            setIsEditing(false); 
            setIsEditingPagos(false); 
            setIsEditingProyectos(false);                       
            
            isInitialMount.current = true;
            //CAMBIO 4-agos-2025: se quita ---->setRegistro(resetRegistro); 
            setRegistro({...REGISTROS_INICIAL});
            //reset form B
            //setSelectedRequisitos({...SELECTED_REQUISITOS_INICIAL}); //donde se resetea usando el context?

            //setTramitacionesExternas([...TRAMITACIONES_EXTERNAS_INICIAL]);//donde se resetea usando el context?
            setTramitacionesInternas({...TRAMITACIONES_INTERNAS_INICIAL});
            setObservacionesReporteEntidad("");
            setObservacionesInternas("");            

            //reset form C
            setEncargadoRendicion("");
            setMontoObraC("");
            setOrganismoEncargado("");
            setEmpresaContratista("");
            setFechaInicioObra("");
            setFechaFinObra("");
            //PENDIENTE: como resetearlos, ahora en el contexto
            //setArrayPagosMejoras([...PAGO_MEJORAS_INICIAL]);
            //setArrayPagosMicrocreditos([...PAGO_MICROCREDITOS_INICIAL]);
            //setArrayPagosProyectos([...PAGO_PROYECTOS_INICIAL]);
            
            setObservSeguimientoObra("");
        }
    }, [estadoAppX])

    //useEffect para deDondeViene - 24JUL2025
    useEffect(()=>{
        console.log("deDondeViene", deDondeViene)
        if(estadoAppX === "nuevo"){
            cambiarDeDondeViene("nuevo")
        } else if(estadoAppX === "ediT"){
            cambiarDeDondeViene("ediT")
        } else if(estadoAppX === "inicial"){
            cambiarDeDondeViene("")
        } else if(estadoAppX === "edit_desde_pagos"){
            cambiarDeDondeViene("edit_desde_pagos")
        } else if(estadoAppX === "edit_desde_proyectos"){
            cambiarDeDondeViene("edit_desde_proyectos")
        }
    }, [estadoAppX])

    //NOTA 19-agos-2025: mantener para MIGRACION
    //cuando se hace dobleclick sobre la fila de la tabla cambia el estado a "ediT"
    
    //**RED**
    const handleEditarRegistro = useCallback((registroE, isEditing = true) => {
        // Extraer array_tipo_subtipo_proyecto y array_obras_expediente del registroE
        const { array_tipo_subtipo_proyecto, array_obras_expediente, ...restoDatos } = registroE;        
        // Actualizar el contexto con los datos del registro a editar
        console.log('Actualizando con datos:', registroE);
        updateSection('identidad', registroE, true);

        if(estadoAppX === "inicial"){
            cambiarEstadoApp("ediT");
        }
    }, [cambiarEstadoApp]);
    
    const newRegistro = useCallback((newExpediente) => {
        setRegistro(newExpediente);
      }, []);

    
    const newEditInput = useCallback((editI) => {
        setEditandoInput(editI);
      }, []);
    
    const newModo = useCallback((newModo) => {
        setModoEdicion(newModo);
      }, []);

    //---> se pasa a TablaInicioContainer
    const handle_EditandoId = useCallback((newId) => {
        setNewEditandoId(newId);
    }, []);

    //handle isEditing ---> se pasa a TablaInicioContainer
    const handleIsEditing = useCallback((newIsEditing) => {
        setIsEditing(newIsEditing);
    }, []); 

    const redirect = async e => {
        e.preventDefault();
        try{
            //setGuardarEstados(true) // -----> INICIA --1--
            
            const x = "guardar_y_salir";
            setIsSavingExit(true);
            //await saveExit(e, x); //, dataSubformulario 
            await handleFinalSave();           

        } catch(err){
            console.error(err);
        }
    }

    const redirect_Cont = async e => {
        e.preventDefault();
        try{
            //setGuardarEstados(true)
            
            const x = "guardar_y_continuar";
            setIsSavingCont(true);
            //await saveExit(e, x); //, dataSubformulario
            await handleFinalSave();

        } catch(err){
            console.error(err);
        }
    }

    // Nueva para RED ---> enviar datos al backend
    const handleFinalSave = async (shouldExit) => {
        // 1. Preparamos el payload
        // Agregamos el id_red si ya existe en la sección de identidad
        const payload = {
            id_red: formData.identidad.id_red || null,
            identidad: formData.identidad,
            legalSocial: formData.legalSocial,
            predio: formData.predio,
            infra: formData.infra,
            vidaDeportiva: formData.vidaDeportiva,
            diagnostico: formData.diagnostico,
            // Aseguramos que el GeoJSON (que está en identidad según el Tab I) sea válido
            geom_sede: formData.geom_sede?.features?.length > 0 
                ? formData.geom_sede 
                : null,
            geom_parcelas: formData.geom_parcelas?.features?.length > 0 
                ? formData.geom_parcelas 
                : null
        };

        console.log("Payload final a enviar:", payload);
        console.log("🔐 Token para Authorization:", token);

        try {
            const response = await fetch('/api/entidades/save', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result.success) {
                // Si el backend generó un ID nuevo, lo actualizamos en el contexto
                
                alert("¡Registro guardado con éxito!");
                // 1. Si era nuevo, ahora tenemos un ID. Actualizamos el contexto ----> en section identidad.
                // 1. Si el backend generó un ID nuevo, lo impactamos en el Contexto
                if (result.id_red) {
                    updateSection('identidad', {
                        ...formData.identidad,
                        id_red: result.id_red
                    });

                    if(shouldExit) {
                        // Para editor_entidad, mostrar resumen descargable (estado 'ver')
                        // NO limpiar datos para permitir volver a editar desde el resumen
                        if (role === 'editor_entidad') {
                            cambiarEstadoApp('ver');
                        } else {
                            // Para otros roles, volver al listado (estado 'inicial') y limpiar
                            cambiarEstadoApp('inicial');
                            getRed();
                            clearPersistedData();
                        }
                    } else {
                        cambiarEstadoApp('ediT');
                    }
                } 
                
            } else {
                throw new Error(result.error || "Error al guardar");
            }
        } catch (error) {
            console.log("Error enviando al backend:", error);
            alert("Hubo un problema al guardar los datos.");
        }
    };

    const saveExit = async (e, x ) => { //registroGuardar //datos (dataSubformulario) no se usa
        //e.preventDefault();      

        try {
            // 1. Recolectar datos del formulario            

			// 2. Preparar el array de geometrías
			// Solo necesitamos 'id' y 'wkt' para enviar al backend
			const geometriesToSend = drawnFeatures.map(f => ({ //featureData
				id: f.id,
				wkt: f.wkt
				// Puedes agregar otros campos si los necesitas en el backend,
				// como un tipo de geometría si es relevante para tu modelo de datos.
				// Por ejemplo: type: f.feature.getGeometry().getType()
			}));

            //usar datos desde formB ----> tramitacioneExternas
            /*const dataToSave = tramitacionesExternas.map(item => ({
                ...item,
                fecha_salida_convenio: item.fecha_salida_convenio ? item.fecha_salida_convenio.toISOString() : null,
                fecha_firma_convenio: item.fecha_firma_convenio ? item.fecha_firma_convenio.toISOString() : null,
                fecha_salida_reso: item.fecha_salida_reso ? item.fecha_salida_reso.toISOString() : null,
                fecha_firma_reso: item.fecha_firma_reso ? item.fecha_firma_reso.toISOString() : null,
            }));*/

            // --- 2. Preparar los datos de formC_SeguimientoObra ---
            /*const preparePagos = (pagosArray) => {
                if (!pagosArray) return [];
                return pagosArray.map(pago => ({
                    ...pago,
                    fecha_pago: pago.fecha_pago ? pago.fecha_pago.toISOString() : null,
                    fecha_certificacion: pago.fecha_certificacion ? pago.fecha_certificacion.toISOString() : null,
                }));
            };
            const preparedPagosMejoras = preparePagos(arrayPagosMejoras);
            const preparedPagosMicrocreditos = preparePagos(arrayPagosMicrocreditos);
            const preparedPagosProyectos = preparePagos(arrayPagosProyectos);*/
            const preparePagos = (pagosArray) => {
                console.log("<----preparePagos - pagosArray---->", pagosArray);
                if (!pagosArray || !Array.isArray(pagosArray)) return [];
                
                return pagosArray.map(pago => {
                    // Función auxiliar para formatear fechas
                    const formatDate = (dateValue) => {
                        if (!dateValue) return null;
                        
                        // Si ya es un string ISO, devolverlo directamente
                        if (typeof dateValue === 'string' && dateValue.endsWith('Z')) {
                            return dateValue;
                        }
                        
                        // Si es un timestamp o string de fecha, convertirlo a Date
                        const date = new Date(dateValue);
                        
                        // Verificar si la fecha es válida
                        if (isNaN(date.getTime())) {
                            console.warn('Fecha inválida:', dateValue);
                            return null;
                        }
                        
                        return date.toISOString();
                    };
            
                    return {
                        ...pago,
                        fecha_pago: formatDate(pago.fecha_pago),
                        fecha_certificacion: formatDate(pago.fecha_certificacion)
                    };
                });
            };
            const preparedPagosMejoras = preparePagos(arrayPagosMejoras);
            const preparedPagosMicrocreditos = preparePagos(arrayPagosMicrocreditos);
            const preparedPagosProyectos = preparePagos(arrayPagosProyectos);


			// 3. Construir el objeto body de la solicitud
			const requestBody = {
                user: user,
				estadoApp: estadoAppX, //hacer cambio en SERVER
                //formA se mantiene sin cambios
                registro: datosGenerales,
                dataSubformulario: tipoSubtipoProyecto,// ya no se pasa como parametro a saveExit, es el subformulario Tipo y Subtipo
                dataSubformularioExpediente: array_obras_expediente,//pasamos en el body array_obras_expediente

                //desde aca viene del formB
                selectedRequisitos,// NO USAR selectedItems,
                tramitacionesInternas: tramitacion,// ANTES era selectedTramitaciones, //agrgado 22-jul-2025 
                observacionesReporteEntidad: reporteEntidad, //acceder desde el contexto
                observacionesInternas: internas,
                observacionesTramitacionExterna: tramitacionExterna, // 9dic-2025
                dataToSave: tramitacionesExternas, //NUEVO 29JUL2025 - PEND.:crear un estado. guarda en la base --->tabla:form_b_tramitacion (nuevo campo de tipo jsonb)

                // Datos de seguimiento de obra
                encargado_rendicion: encargadoRendicion,
                monto_obraC: montoObra, //usar desde el contexto y no ---> monto_obraC, //en FormC_SeguimientoObra, pero viene desde registro.monto_obra
                organismo_encargado: organismoEncargado,
                empresa_contratista: empresaContratista,
                fecha_inicio_obra: fechaInicioObra,
                fecha_fin_obra: fechaFinObra,
                observ_seguimiento_obra: observacionesSeguimientoObra,

                // Pagos serializados
                arrayPagosMejoras: preparedPagosMejoras,
                arrayPagosMicrocreditos: preparedPagosMicrocreditos,
                arrayPagosProyectos: preparedPagosProyectos,

                geometries: geometriesToSend
			};

			console.log('Objeto body de la solicitud:', requestBody);

            // Preparar token JWT para autorización del backend
            const rawToken = localStorage.getItem('token');
            const token = rawToken ? JSON.parse(rawToken) : null;

            if(x === "guardar_y_salir"){
                console.log("OSO llega?")

				const response = await fetch(
					`/api/nuevaObra`,
					{
						method: "POST",
						headers: {
							"Content-type": "application/json",
							'X-Socket-Id': socketRef.current?.id || socket?.id || '',
							...(token ? { 'Authorization': `Bearer ${token}` } : {})
						},
						body: JSON.stringify(requestBody)
					}
				);

                // Manejo específico de sesión expirada
                if (response.status === 401 || response.status === 403) {
                    toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.');
                    window.location.assign('/login');
                    return;
                }

                const respuesta_json = await response.json();
                //console.log("RESPUESTA DESPUES DEL CAMBIO", respuesta_json)


                if (respuesta_json.id_origen === undefined){
                    console.log('1');
                    toast.error(`El Proyecto ya existe, intente nuevamente.`);
                } else {                   
                    

                    if(respuesta_json.activo ===1){ //si es nuevo
                        setData(prevData => [respuesta_json, ...prevData ]);
                        clearFeatures(); //borra las features del mapa
                        toast("¡Operación exitosa!, nuevo registro creado")
                    } else if(respuesta_json.activo ===2){ //si es una actualizacion
                        console.log("2 - Actualizando")
                        //quitarIdEdicion(registro.id_partido_obra);
                        quitarIdEdicion(datosGenerales.id_partido_obra)
                        setData(prevData => {
                            const newData = prevData.map(item => {
                                if (item.id_origen === respuesta_json.id_origen) {
                                    return respuesta_json; // **REEMPLAZA el objeto antiguo con el nuevo objeto actualizado**
                                } else {
                                    return item;      // Deja los demás objetos sin cambios
                                }
                            });
                            return newData; // Devuelve el *nuevo* array con el objeto actualizado
                        });
                        toast("¡Operación exitosa!, registro editado")
                    }
                    

                    //setEstadoApp("inicial") // Vuelve al estado inicial al guardar y salir
                    

                    if (estadoAppX === "edit_desde_pagos" || estadoAppX === "edit_desde_proyectos"){
            
                        //if (origenNavegacion === "tramitaciones") {
                            const tabOrigen = localStorage.getItem('lastActiveTab'); //location.state?.origen; // 'pagos' o 'proyectos'
                            console.log('Navegando a /tramitaciones con tab:', tabOrigen);
                            if (tabOrigen) { // Solo si hay un origen específico
                                console.log("TIENE tabOrigen")
                                navigate(`/tramitaciones?edicionExitosa=true`, {
                                    //state: {
                                    //    tabActivo: tabOrigen
                                    //},----> usar origen desde locastorage: lastActiveTab
                                    replace: true // Para no guardar en el historial
                                });
                            } else {
                                console.log("NO TIENE tabOrigen")
                                // Si no hay origen específico, navegar sin forzar el tab
                                navigate(`/inicio`, { replace: true });
                            }
                        //}
                        clearFeatures(); //borra las features del mapa
                        setBloquear(false);
                        toast("¡Operación exitosa!, registro editado")
                    }

                    //limpiar de localStorage id_partido_obra
                    localStorage.removeItem('idPartidoObra');
                    cambiarEstadoApp("inicial");

                    //setGuardarEstados(false); // ------>                   
                }


            } else if(x==="guardar_y_continuar"){

                //alert("Guardar y continuar. Estado tiene que cambiar a EDIT (si salio todo bien en el primer save)")
                console.log("primero fue nuevo, segunda vuelta es edit")

				const response = await fetch(
					`/api/nuevaObra`,
					{
						method: "POST",
						headers: {
							"Content-type": "application/json",
							'X-Socket-Id': socketRef.current?.id || socket?.id || '',
							...(token ? { 'Authorization': `Bearer ${token}` } : {})
						},
						body: JSON.stringify(requestBody)
					}
				);

                // Manejo específico de sesión expirada
                if (response.status === 401 || response.status === 403) {
                    toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.');
                    window.location.assign('/login');
                    return;
                }

                const parseRes = await response.json();
                console.log("parseRes en guardar y continuar", parseRes)


                if (parseRes.id === undefined){
                    alert(`El expediente ya existe, intente nuevamente.`);
                //} else if (parseRes.id !== undefined ){//&& parseRes.id !== parseRes.id_origen --> son distintos porque id es el incremental y id_origen es donde comenzo la obra
                } else if (estadoAppX === 'nuevo') {   

                    /*setRegistro({...registro,
                        id_obra:parseRes.id_obra,
                        id_origen : parseRes.id_origen,
                        id_partido_obra: parseRes.id_partido_obra, //.cg_01_id_partido_obra
                        //fecha_actualizacion: parseRes.fecha_actualizacion
                    }); */
                    //tambien actualizar id_obra en formA

                    updateField('formA', 'datosGenerales', 'id_obra', parseRes.id_obra);
                    updateField('formA', 'datosGenerales', 'id_origen', parseRes.id_origen); 
                    updateField('formA', 'datosGenerales', 'id_partido_obra', parseRes.id_partido_obra); 
                    updateField('formA', 'datosGenerales', 'fecha_actualizacion', parseRes.fecha_actualizacion);                    

                    toast("¡Operación exitosa!, registro nuevo - CONT")
                    //setEstadoApp("ediT"); // Cambia al estadoApp 'ediT' al guardar y continuar después de crear
                    cambiarEstadoApp("ediT");
                    setNewEditandoId(parseRes.id_partido_obra);
                    console.log("ACAA")

                    // Añadir el nuevo registro a setData para que aparezca en la tabla
                    setData((prevData) => [parseRes, ...prevData]);
                } else if (estadoAppX === 'ediT') {
                    /*setRegistro({...registro,
                        //id_obra:parseRes.id_obra,
                        //id_origen : parseRes.id_origen,
                        //id_partido_obra: parseRes.id_partido_obra, //.cg_01_id_partido_obra
                        fecha_actualizacion: parseRes.fecha_actualizacion
                    });*/
                    updateField('formA', 'datosGenerales', 'fecha_actualizacion', parseRes.fecha_actualizacion);
                    toast("¡Operación exitosa!, registro editado - CONT")

                    setData(prevData => {
                        const newData = prevData.map(item => {
                            if (item.id_origen === parseRes.id_origen) {
                                return parseRes; // **REEMPLAZA el objeto antiguo con el nuevo objeto actualizado**
                            } else {
                                return item;      // Deja los demás objetos sin cambios
                            }
                        });
                        return newData; // Devuelve el *nuevo* array con el objeto actualizado
                    });
                    //mantenemos esta ediT
                    
                }

            }

        } catch(err){
            console.error(err);
        } finally {
            // Restablecer estados de carga según la acción
            if (x === "guardar_y_salir") {
                setIsSavingExit(false);
            } else if (x === "guardar_y_continuar") {
                setIsSavingCont(false);
            }
        }
    }

    

    // *****INICIA UseEffect********************
    useEffect(()=>{
        console.log("AUX ejecutando")
        setMontoObraC(datosGenerales.monto_obra)
    }, [datosGenerales?.monto_obra])    

    useEffect(() => {
        //getObras(true);//POR ahora solo comentamos, luego eliminar de desarrollo

        getRed()
    }, [])
    
    // Efecto para detectar y manejar modo edición por token de entidad (registro desde email)
    useEffect(() => {
        // Verificar si llegamos desde la página de registro con token
        const fromRegistro = location.state?.fromRegistro;
        const entidadToken = location.state?.entidadToken || sessionStorage.getItem('entidadToken');
        const entidadIdRedFromStorage = location.state?.entidadIdRed || sessionStorage.getItem('entidadIdRed');
        const entidadDataStr = sessionStorage.getItem('entidadData');
        
        if (entidadToken && entidadIdRedFromStorage) {
            // Estamos en modo edición por token
            setIsEntidadTokenMode(true);
            
            // Guardar en sessionStorage si viene de location.state
            if (fromRegistro && location.state?.entidadToken) {
                sessionStorage.setItem('entidadToken', location.state.entidadToken);
                sessionStorage.setItem('entidadIdRed', location.state.entidadIdRed);
                if (location.state?.entidadData) {
                    sessionStorage.setItem('entidadData', JSON.stringify(location.state.entidadData));
                }
            }
            
            // Cargar datos de la entidad y poner en modo edición
            const loadEntidadData = async () => {
                try {
                    // Primero intentamos obtener los datos de la entidad
                    const response = await fetch(`/api/entidades/datos_entidad/${entidadIdRedFromStorage}`);
                    if (response.ok) {
                        const data = await response.json();
                        console.log("Datos de entidad cargados por token:", data);
                        
                        // Actualizar el estado con los datos de la entidad
                        if (data) {
                            const entidadData = Array.isArray(data) && data.length > 0 ? data[0] : data;
                            
                            // Actualizar el contexto con los datos de la entidad
                            if (entidadData.identidad) {
                                updateSection('identidad', entidadData.identidad, true);
                            }
                            if (entidadData.legalSocial) {
                                updateSection('legalSocial', entidadData.legalSocial, true);
                            }
                            if (entidadData.predio) {
                                updateSection('predio', entidadData.predio, true);
                            }
                            if (entidadData.infra) {
                                updateSection('infra', entidadData.infra, true);
                            }
                            if (entidadData.vidaDeportiva) {
                                updateSection('vidaDeportiva', entidadData.vidaDeportiva, true);
                            }
                            if (entidadData.diagnostico) {
                                updateSection('diagnostico', entidadData.diagnostico, true);
                            }
                            
                            // Poner en modo edición (simula doble clic en TablaRed)
                            cambiarEstadoApp('ediT');
                        }
                    } else {
                        console.error("Error al cargar datos de entidad:", response.statusText);
                    }
                } catch (error) {
                    console.error("Error cargando datos de entidad por token:", error);
                }
            };
            
            loadEntidadData();
        }
    }, [location.state, cambiarEstadoApp, updateSection]);

    useEffect(()=>{        
        consultar_array_editando(); //ahora para todos los usuarios
        
    }, [])

    //un useEffcet para detecatar cambios en escuchandoLocalData
    useEffect(() => {
        console.log("escuchandoLocalData", escuchandoLocalData)
        //modificar registro de manera funcional con el valor en escuchandoLocalData
        setRegistro(prevRegistro => ({
            ...prevRegistro,
            nombre_obra: escuchandoLocalData.nombre_obra
        }));
    }, [escuchandoLocalData])
    
    // useEffect para inicializar tramitacionesExternas basado en array_obras_expediente
    /*useEffect(() => {
        if (registro?.array_obras_expediente && registro?.array_obras_expediente.length > 0) {
            const initialTramitaciones = registro?.array_obras_expediente.map((obraExp, idx) => ({
                id: `exp-${obraExp.expediente_o}-${idx}`, // Generar un ID único basado en el expediente y un índice
                exp: obraExp.expediente_o, // Asignar el valor del expediente_o
                fecha_salida_convenio: null,
                fecha_firma_convenio: null,
                fecha_salida_reso: null,
                fecha_firma_reso: null,
            }));
            setTramitacionesExternas(initialTramitaciones);
        } else {
            // Si no hay expedientes, asegurarnos de que el estado esté vacío o con un valor por defecto si lo prefieres
            setTramitacionesExternas([]);
        }
    }, [registro?.array_obras_expediente]);*/ // ¡Importante! Este useEffect se ejecutará cuando array_obras_expediente cambie

    /* //31-JUL-25
    useEffect(() => {
        setTramitacionesExternas(prevTramitaciones => {
            const newTramitaciones = [];
            const existingTramitacionesMap = new Map(
                prevTramitaciones.map(t => [t.exp, t]) // Mapea las tramitaciones existentes por su 'exp'
            );

            registro?.array_obras_expediente.forEach((obraExp, idx) => {
                const expediente_o = obraExp.expediente_o;
                const existingTramitacion = existingTramitacionesMap.get(expediente_o);

                if (existingTramitacion) {
                    console.log("YA EXISTE UNA TRAMITACION PARA ESTE EXPEDIENTE", existingTramitacion)
                    // Si ya existe una tramitación para este expediente_o, la reutilizamos
                    // y nos aseguramos de que el ID esté actualizado si el orden cambió
                    newTramitaciones.push({
                        ...existingTramitacion,
                        id: `exp-${expediente_o}-${idx}`, // Actualizamos el ID por si el índice cambió
                        exp: expediente_o // Aseguramos que 'exp' sea el correcto
                    });
                } else {
                    // Si no existe, creamos una nueva tramitación con valores por defecto
                    newTramitaciones.push({
                        id: `exp-${expediente_o}-${idx}`,
                        exp: expediente_o,
                        fecha_salida_convenio: null,
                        fecha_firma_convenio: null,
                        fecha_salida_reso: null,
                        fecha_firma_reso: null,
                    });
                }
            });
            return newTramitaciones;
        });
    }, [registro?.array_obras_expediente]); // Se ejecuta cuando array_obras_expediente cambia    

    //si se encontaron datos del form_b (busqueda por id)    
    useEffect(()=>{
        if(formularioConsultado){
            console.log("mostrar que tiene formularioConsultado", formularioConsultado)
            const documentos = formularioConsultado.documentos_seleccionados;
            const observaciones_reporte = formularioConsultado.observaciones_reporte;
            const observaciones_internas = formularioConsultado.observaciones_internas;
            const tramitacionesInternas = formularioConsultado.tramitacion_interna_jsonb;
            const tramitacionesExternas = formularioConsultado.tramitacion_externa_jsonb;

            //setSelectedItems(documentos) //NOTA: Estaba comentado (por qué??) 27-jul-2025
            setSelectedRequisitos(documentos) //NOTA ES ESTE EL QUE HAY QUE USARsaveExit
            setObservacionesReporteEntidad(observaciones_reporte)
            setObservacionesInternas(observaciones_internas)
            setTramitacionesInternas(tramitacionesInternas)
            console.log("ENTRA ACA?")
            setTramitacionesExternas(tramitacionesExternas)
        }

    }, [formularioConsultado])*/

    // Segundo useEffect: Procesa los datos de formularioConsultado una vez que se carga
    //VERFIFICAR  5dic25 ----> formulario consultado
    
    useEffect(() => {

        const tramitacionInternaTemp = { 
            registracion_ong: "",
            resolucion_ong: "",
            documentacion_ong: "",
            informe_tecnico: "", //nuevo requisito 22-jul-2025
            modelo_convenio: "",        
            proyecto_resolucion: "",
            resolucion: "",
            programa: ""
        };
        if (formularioConsultado) {
            console.log("Procesando formularioConsultado:", formularioConsultado);

            // Actualiza los estados de otros datos del formulario
            //setSelectedRequisitos(formularioConsultado.documentos_seleccionados || []); //comentar por ahora hasta verficar formulario consultado
            setObservacionesReporteEntidad(formularioConsultado.observaciones_reporte || '');
            setObservacionesInternas(formularioConsultado.observaciones_internas || '');
            setTramitacionesInternas(formularioConsultado.tramitacion_interna_jsonb || tramitacionInternaTemp); // || null

            // --- Lógica Clave para tramitacionesExternas ---
            //ya no es registro.array_obras_expediente ahora directamente desde el context (array_obras_expediente)
            const loadedArrayObrasExpediente = array_obras_expediente || []; //formularioConsultado.array_obras_expediente || [];
            const loadedTramitacionesExternasBD = formularioConsultado.tramitacion_externa_jsonb || [];

            // Convertir las tramitaciones externas cargadas a un mapa para búsqueda rápida
            const tramitacionesBDMap = new Map(
                loadedTramitacionesExternasBD.map(t_bd => [
                    t_bd.exp, // La clave es el nombre del expediente
                    {
                        ...t_bd,
                        // ¡IMPORTANTE! Convertir strings ISO de vuelta a objetos Date
                        fecha_salida_convenio: t_bd.fecha_salida_convenio ? new Date(t_bd.fecha_salida_convenio) : null,
                        fecha_firma_convenio: t_bd.fecha_firma_convenio ? new Date(t_bd.fecha_firma_convenio) : null,
                        fecha_salida_reso: t_bd.fecha_salida_reso ? new Date(t_bd.fecha_salida_reso) : null,
                        fecha_firma_reso: t_bd.fecha_firma_reso ? new Date(t_bd.fecha_firma_reso) : null,
                    }
                ])
            );

            // Construir el array final de tramitacionesExternas para el estado del formulario
            const finalTramitacionesExternas = loadedArrayObrasExpediente.map((obraExp, idx) => {
                const expediente_o = obraExp.expediente_o;
                const existingTramitacion = tramitacionesBDMap.get(expediente_o);

                if (existingTramitacion) {
                    // Si existe en los datos cargados de la BD, usamos esos datos
                    return {
                        ...existingTramitacion,
                        id: `exp-${expediente_o}-${idx}`, // Aseguramos el ID correcto para React keys
                        exp: expediente_o // Confirmamos el nombre del expediente
                    };
                } else {
                    // Si es un expediente nuevo (no vino en la BD), lo inicializamos
                    return {
                        id: `exp-${expediente_o}-${idx}`,
                        exp: expediente_o,
                        fecha_salida_convenio: null,
                        fecha_firma_convenio: null,
                        fecha_salida_reso: null,
                        fecha_firma_reso: null,
                    };
                }
            });

            // Actualizar los estados finales
            //setTramitacionesExternas(finalTramitacionesExternas); //comentar por ahora hasta verficar formulario consultado
        }
    }, [formularioConsultado]); // Este useEffect se ejecuta solo cuando formularioConsultado cambia
    

    // useEffect #3: Sincronización de tramitacionesExternas cuando cambia array_obras_expediente
    // Su rol es MANTENER LA SINCRONIZACIÓN en tiempo real.
    //este USEeFFECT podŕia irse, verificar que exp_o se agregue en formB_tramitacion
    /*useEffect(() => {

        // Si no hay expedientes, no hacemos nada.
        // Esto es un "defensive programming" aunque la UI ya previene de que por lo menos haya un expediente.
        //ya no es registro.array_obras_expediente ahora directamente desde el context (array_obras_expediente)
        if (array_obras_expediente.length === 0) return;

        // Solo actúa si array_obras_expediente ya tiene datos
        setTramitacionesExternas(prevTramitaciones => {
            const newTramitaciones = [];
            const existingTramitacionesMap = new Map(
                prevTramitaciones.map(t => [t.exp, t])
            );

            array_obras_expediente.forEach((obraExp, idx) => {
                const expediente_o = obraExp.expediente_o;
                const existingTramitacion = existingTramitacionesMap.get(expediente_o);
                const objeto_o = obraExp.objeto_o;

                if (existingTramitacion) {
                    newTramitaciones.push({
                        ...existingTramitacion,
                        id: `exp-${expediente_o}-${idx}`,
                        exp: expediente_o,
                        objeto: objeto_o
                    });
                } else {
                    newTramitaciones.push({
                        id: `exp-${expediente_o}-${idx}`,
                        exp: expediente_o,
                        objeto: objeto_o,
                        fecha_salida_convenio: null,
                        fecha_firma_convenio: null,
                        fecha_salida_reso: null,
                        fecha_firma_reso: null,
                    });
                }
            });
            return newTramitaciones;
        });
    }, [array_obras_expediente]);*/

    //useEffect al recibir cambios en formularioSeguimientoObra
    useEffect(()=>{
        if (formularioSeguimientoObra) {
            console.log("FormularioSeguimientoObra actualizado:", formularioSeguimientoObra);
            
            // Actualizar los estados individuales con los datos del formulario
            if (formularioSeguimientoObra.encargado_rendicion) {
                setEncargadoRendicion(formularioSeguimientoObra.encargado_rendicion);
            }
            if (formularioSeguimientoObra.organismo_encargado) {
                setOrganismoEncargado(formularioSeguimientoObra.organismo_encargado);
            }
            if (formularioSeguimientoObra.empresa_contratista) {
                setEmpresaContratista(formularioSeguimientoObra.empresa_contratista);
            }
            if (formularioSeguimientoObra.monto_obraC) {
                setMontoObraC(formularioSeguimientoObra.monto_obraC);
            }
            // Manejar campos de pagos (pueden venir como string JSON o ya como objeto)
            if (formularioSeguimientoObra.pago_mejoras_jsonb) {
                const pagosMejoras = typeof formularioSeguimientoObra.pago_mejoras_jsonb === 'string' 
                    ? JSON.parse(formularioSeguimientoObra.pago_mejoras_jsonb)
                    : formularioSeguimientoObra.pago_mejoras_jsonb;
                //setArrayPagosMejoras(pagosMejoras);
            }
            if (formularioSeguimientoObra.pago_microcreditos_jsonb) {
                const pagosMicrocreditos = typeof formularioSeguimientoObra.pago_microcreditos_jsonb === 'string'
                    ? JSON.parse(formularioSeguimientoObra.pago_microcreditos_jsonb)
                    : formularioSeguimientoObra.pago_microcreditos_jsonb;
                //setArrayPagosMicrocreditos(pagosMicrocreditos);
            }
            if (formularioSeguimientoObra.pago_proyectos_jsonb) {
                const pagosProyectos = typeof formularioSeguimientoObra.pago_proyectos_jsonb === 'string'
                    ? JSON.parse(formularioSeguimientoObra.pago_proyectos_jsonb)
                    : formularioSeguimientoObra.pago_proyectos_jsonb;
                //setArrayPagosProyectos(pagosProyectos);
            }
            if (formularioSeguimientoObra.observ_seguimiento_obra) {
                setObservSeguimientoObra(formularioSeguimientoObra.observ_seguimiento_obra);
            }
            //fecha_inicio_obra y fecha_fin_obra
            if (formularioSeguimientoObra.fecha_inicio_obra) {
                setFechaInicioObra(formularioSeguimientoObra.fecha_inicio_obra);
            }
            if (formularioSeguimientoObra.fecha_fin_obra) {
                setFechaFinObra(formularioSeguimientoObra.fecha_fin_obra);
            }
        }
    }, [formularioSeguimientoObra])
    

    //NOTA: si cambia id editando ---> llamar function getFormB_Tramitacion y getFormC_SeguimientoObra 
    //NOTA: comentar para RED
    useEffect(()=>{
        if(new_EditandoId){
            //console.log("ahora tiene valor, pegar a endpoint")
            //getFormB_Tramitacion() //B
            //getFormC_SeguimientoObra() //pestaña C
        }

    }, [new_EditandoId])

    //si cambia id editando ---> llamar function getGeometriesByObraId -9jul25-
    useEffect(()=>{
        if(new_EditandoId){
            //console.log("ahora tiene valor, pegar a endpoint")
            loadFeaturesForObra(new_EditandoId)
        }
    }, [new_EditandoId])
        


    useEffect(()=>{
        console.log("manejar todos los cambios de new_ EMIT--->", new_EditandoId)
        if(socket){
            //if new_EditandId tiene valor, emitirlo. No puede ser vacio ""
            if(new_EditandoId){
                socket.emit("editando_id", new_EditandoId ) // por ahora COMENTAR #27FEB25
            }
        }
    }, [new_EditandoId]) //new_EditandoId


    /*
    NOTA: para determinar "EDICION INICIADA POR ---->", usuarioInicial //POR AHORA COMENTAR 17-oct-2025
    useEffect(()=>{
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        const busqueda = safeArray.filter((editando)=>{return editando.id_edit === new_EditandoId})

        if(busqueda.length > 0){
            console.log("YA SE ESTA EDITANDO", busqueda)
            setBusquedaUsuarios(busqueda)
        }

    },[new_EditandoId])


    useEffect(()=>{
        if(busquedaUsuarios.length > 0){
            const usuarioInicial = busquedaUsuarios[0]["user_edit"]
            console.log("EDICION INICIADA POR ---->", usuarioInicial)
            setBloquear(true)
        }

    }, [busquedaUsuarios])
    */


    // DESCOMENTAR 14OCT25
    useEffect(()=>{
        if(socket){
            console.log("ESTÄ ESCUCHANDO??")
            const procesarArray = (data) =>{
                console.log("ESCUCHAR CAMBIOS aca´ --->", data)
                setArrayEditando(data)
            }
            socket.on("array_editando", procesarArray)

            return () => {
                socket.off("array_editando", procesarArray)
            }
        }
    }, [socket])


    /* VERIFICAR si se va este useEffect (#5dic25)
    useEffect(() => {

        setSelectedRequisitos((prevSelected) => {
            const updatedState = { ...prevSelected };
            if (registro.tipo_subsidio !== "ONG") {
                updatedState["Registración ONG"] = false;
            }
            if (registro.tipo_subsidio !== "Subsidio a Municipio") {
                updatedState["Designación Intendente"] = false;
            }
            return updatedState;
        });

    }, [registro.tipo_subsidio]);
    */


    useEffect(() => {

        if(socket){

            const procesarNuevaObra = (socket) => {

                console.log("NUEVA OBRA", socket);

                setNuevaObra(true)
                setData(socket)
                setTimeout(setNuevaObra(false), 1000)

            }

            socket.on("nueva_obra", procesarNuevaObra)

            return () => {
                socket.off("nueva_obra", procesarNuevaObra)
            }
        }

    }, [socket])    

    useEffect(() => { //ver OPCION 1
        //console.log("QUE TIENE REGUSTRO EN EL CLIENTE", registro)
        if(estadoAppX ==="ediT" && modoEdicion === "manual"){

            if(editandoInput.id_input_editando !== null){
                if(socket){
                    socket.emit("A - editando registro", registro.id_partido_obra, registro)
                }
            }
        }
    }, [registro] )

    useEffect(() => {
        if(socket){

            const escuchandoNuevoEstado = (socket) => {

                setModoEdicion("remoto")

                console.log("RECIBEN TODOS MENOS EL QUE INICIO LA EDICION", socket)

                setRegistro(socket)
            }
            socket.on("C - array editando", escuchandoNuevoEstado)

            return () => {
                socket.off("C - array editando", escuchandoNuevoEstado)
            }
        }

    }, [registro])

    /* CHEQUEAR SI QUEDA #22FEB25
    useEffect(()=>{
        console.log("formRows ---> CAMBIO EN array_obras_expediente")
        if(estadoApp ==="ediT" && modoEdicion === "manual"){
            if(socket){
                socket.emit("Z - cambio en formRows", registro.id_partido_obra, formRows )
            }
        }

    },[formRows])
    */

    

    //NOTA 5-agos-2025: asegura que se ejecute el useEffect cuando es ediT y isInitialMount es true
    //al salir de la edicion, isInitialMount vuelve a ser true
    useEffect(() => {
        if (estadoAppX === "ediT") {


            if (isInitialMount.current) {
                isInitialMount.current = false;
                return;
            }

            if (registro.programa_lineamiento) {
                setRegistro(prev => ({
                    ...prev,
                    modalidad: '' // Resetear modalidad
                }));
            }
        }
    }, [registro.programa_lineamiento])

    useEffect(() => {
        if (registro.lc_22_identificacion_catastral === 'NO') {
            setRegistro(prev => ({
                ...prev,
                lc_22_1_datos_catastrales: '' // Resetear datos catastrales
            }));
        }
    }, [registro.lc_22_identificacion_catastral])   

    useEffect(() => {
        if (registro.barrio_tipo === 'RPPVAP') {
            setRegistro(prev => ({
                ...prev,
                barrio_otro_nombre: '' // Resetear nombre de barrio Otro
            }));
        } else if (registro.barrio_tipo === 'OTRO') {
            setRegistro(prev => ({
                ...prev,
                barrio_rppvap_nombre: null // Resetear selección RPPVAP
            }));
        } else if (registro.barrio_tipo === '' || registro.barrio_tipo === null) {
            setRegistro(prev => ({
                ...prev,
                barrio_otro_nombre: '',
                barrio_rppvap_nombre: null
            }));
        }
    }, [registro.barrio_tipo]) 

    //implementar un handler para escuchar localData desde formA handleSincronizarDatos
    const handleLocalDataChange = (localData) => {
        console.log('PUMA solo escuchar LocalData recibida desde formA:', localData);
        setEscuchandoLocalData(localData);
        // Aquí puedes actualizar el estado del padre con los datos locales
        //setRegistro(prev => ({ ...prev, ...localData }));
    };
    

    // Update the data for the table and store it in state for reference
    const handleDataLoaded = (data) => {
        setDataForTable(data);
        return data; // Return the data to allow chaining if needed
    };

    return (
        <>
            <div className="">
            <div className="flex flex-row flex-auto justify-center items-center p-2 ">                
                { (user === 'Javier' ||user === 'Datos') && (
                    <>
                        <p>
                            User: {user}<br />
                            Estado X es: {estadoAppX}<br />
                            IsEditing: {isEditing}<br />
                            IsEditingProyectos: {isEditingProyectos}<br />
                            IsEditingPagos: {isEditingPagos}<br />
                            Pruebas X para pagina inicial `${estadoAppX === "ediT" || estadoAppX === "nuevo" ? "FORM=true" : "TABLE=true"}`<br />
                            {nueva_obra === true && estadoAppX === "inicial" ? `Nueva obra disponible. Cargar X` : ``}<br />
                            {modoEdicion}
                        </p>
                        <details className="mt-4 p-4 bg-gray-50 rounded-lg">
                            <summary className="font-medium text-gray-700 cursor-pointer">Datos del informe (depuración)</summary>
                                <pre>{JSON.stringify(array_obras_expediente, null, 2)}</pre>
                                <pre className="mt-2 p-2 bg-white border rounded overflow-auto max-h-40">
                                    {JSON.stringify(tramitacionesExternas, null, 2)}
                                </pre>
                        </details>
                    </>
                )}
            </div>            

            {/* Banner de actualización manual cuando hay cambios remotos */}
            {(estadoAppX === "inicial" && pendingUpdates) && (
              <div className="mx-2 my-2 p-3 rounded-md bg-amber-100 border border-amber-300 flex items-center justify-between gap-3">
                <div className="text-amber-900 text-sm">
                  {lastUpdateInfo?.type === 'created' && (
                    <>Nuevo proyecto disponible{lastUpdateInfo?.nombre_obra ? `: "${lastUpdateInfo.nombre_obra}"` : ''}{lastUpdateInfo?.by_user ? ` (por ${lastUpdateInfo.by_user})` : ''}.</>
                  )}
                  {lastUpdateInfo?.type === 'updated' && (
                    <>Se modificó proyecto{lastUpdateInfo?.nombre_obra ? `: "${lastUpdateInfo.nombre_obra}"` : ''}{lastUpdateInfo?.by_user ? ` (por ${lastUpdateInfo.by_user})` : ''}.</>
                  )}
                  {!lastUpdateInfo?.type && (
                    <>Hay cambios en obras{lastUpdateInfo?.nombre_obra ? `: "${lastUpdateInfo.nombre_obra}"` : ''}{lastUpdateInfo?.by_user ? ` (por ${lastUpdateInfo.by_user})` : ''}.</>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <Button onClick={applyPendingUpdates}>Actualizar datos</Button>
                  <button
                    onClick={() => setPendingUpdates(false)}
                    className="px-3 py-2 text-sm text-amber-900 hover:text-amber-700"
                  >
                    Ocultar
                  </button>
                </div>
              </div>
            )}

            <div className="flex flex-col justify-start flex-1 p-2 ">
                {/* Cuando hay borrador, mostrar primero el div con botón Continuar */}
                {estadoAppX === "inicial" && hasDraftData && (
                    <div className="mb-4 p-4 bg-blue-50 rounded-xl border border-blue-200 shadow-sm">
                        <div className="flex items-center justify-between mb-3">
                            <span className="text-blue-700 font-bold uppercase text-xs">Borrador Guardado</span>
                            <div className="flex items-center gap-2">
                                <span className="px-2 py-1 rounded-full text-xs font-bold bg-orange-100 text-orange-700">
                                    Pendiente
                                </span>
                                <button
                                    type="button"
                                    onClick={() => {
                                        clearPersistedData();
                                        setHasDraftData(false);
                                    }}
                                    className="text-gray-400 hover:text-red-500 transition-colors"
                                    title="Descartar borrador"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p className="text-sm text-blue-900 mb-3">
                            Tienes una entidad en progreso sin guardar en el servidor
                        </p>
                        <Button 
                            type="button"
                            variant="secondary" 
                            onClick={handleContinuarNuevo}                            
                        >
                            CONTINUAR CARGA EN PROGRESO 
                        </Button>
                    </div>
                )}

                {/* Indicador de borrador para editor_entidad en modo edición */}
                {estadoAppX === "ediT" && role === 'editor_entidad' && hasDraftData && (
                    <div className="mb-4 p-4 bg-amber-50 rounded-xl border border-amber-200 shadow-sm">
                        <div className="flex items-center justify-between mb-3">
                            <span className="text-amber-700 font-bold uppercase text-xs">Borrador Pendiente</span>
                            <div className="flex items-center gap-2">
                                <span className="px-2 py-1 rounded-full text-xs font-bold bg-orange-100 text-orange-700">
                                    Sin guardar
                                </span>
                                <button
                                    type="button"
                                    onClick={() => {
                                        // Solo limpiar localStorage, NO el formulario actual (para editor_entidad en ediT)
                                        localStorage.removeItem('red_form_draft');
                                        if (entidadId) {
                                            localStorage.setItem('red_form_draft_dismissed', entidadId);
                                        }
                                        setHasDraftData(false);
                                        draftIndicatorDismissedRef.current = true;
                                    }}
                                    className="text-gray-400 hover:text-red-500 transition-colors"
                                    title="Descartar borrador"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p className="text-sm text-amber-900 mb-3">
                            Tienes cambios sin guardar en el servidor. Los datos mostrados son los del servidor.
                        </p>
                        <Button 
                            type="button"
                            variant="secondary" 
                            onClick={() => {
                                draftIndicatorDismissedRef.current = true; // Marcar PRIMERO para que el useEffect lo respete
                                setHasDraftData(false); // Ocultar indicador inmediatamente
                                handleContinuarNuevo(); // Luego recuperar el borrador
                            }}                            
                        >
                            RECUPERAR BORRADOR LOCAL
                        </Button>
                    </div>
                )}
                
                {(estadoAppX !== 'previewViabilidadTécnica' && estadoAppX !== 'previewInformeTecnicoObservaciones' && estadoAppX !== 'ver') && (
                    (estadoAppX !== 'inicial' || role !== 'editor_entidad') && (
                        <Button variant="subse" type="submit" onClick={toggle}>
                            {estadoAppX === "inicial" ? "NUEVA ENTIDAD DEPORTIVA" : "CANCELAR"}
                        </Button>
                    )
                )}
            </div>

            <div className={`${estadoAppX === 'inicial' ? "block" : "hidden"} w-full`}>
                <RedInicioContainer 
                    ref={tableInicioRef}
                    data={dataRED} 
                    isLoading={loading} 
                    onEditarRegistro={handleEditarRegistro}
                    setNewEditandoId={setNewEditandoId}
                    handlePreviewClick={handlePreviewClick}
                    arrayEditando={arrayEditando}
                    handleIsEditing={handleIsEditing}
                    onDataLoaded={handleDataLoaded}
                />
            </div>
            
            {/*<div className={`${estadoAppX === 'inicial' ? "block" : "hidden"} w-full`}>
                <TablaInicioContainer 
                    ref={tableInicioRef}
                    data={data} 
                    isLoading={loading} 
                    onEditarRegistro={handleEditarRegistro}
                    setNewEditandoId={setNewEditandoId}
                    handlePreviewClick={handlePreviewClick}
                    arrayEditando={arrayEditando}
                    handleIsEditing={handleIsEditing}
                    onDataLoaded={handleDataLoaded}
                />
            </div> */}           

            <div className={`${(estadoAppX === 'nuevo' || estadoAppX === 'continuar_nuevo' || estadoAppX === 'ediT' || estadoAppX === 'edit_desde_pagos' || estadoAppX === 'edit_desde_proyectos') ? "block" : "hidden"}`}>
                <div className="flex flex-col mb-6 p-4 bg-gray-100 dark:bg-gray-900 rounded-lg shadow-sm">
                    { (estadoAppX === 'ediT' || estadoAppX === 'edit_desde_pagos' || estadoAppX === 'edit_desde_proyectos') && (
                        isEditingPagos === "true" || isEditingProyectos === "true"
                            ? <span className="text-red-600 dark:text-red-400">-MODO SOLO LECTURA- Este registro está siendo editado por otro usuario</span>
                            : ''
                    )}
                    { (estadoAppX === 'ediT' || estadoAppX === 'edit_desde_pagos' || estadoAppX === 'edit_desde_proyectos') && (
                        isEditing
                            ? <span className="text-red-600 dark:text-red-400">-MODO SOLO LECTURA- Este registro está siendo editado por otro usuario</span>
                            : ''
                    )}
                    {/*{ estadoAppX === 'edit_desde_pagos' && (
                        isEditing === "true"
                            ? <span className="text-red-600 dark:text-red-400">-MODO SOLO LECTURA- Este registro está siendo editado por otro usuario</span>
                            : ''
                    )}
                    { estadoAppX === 'edit_desde_pagos' && (
                        isEditingProyectos === "true"
                            ? <span className="text-red-600 dark:text-red-400">-MODO SOLO LECTURA- Este registro está siendo editado por otro usuario desde Tramitacion Proyectos</span>
                            : ''
                    )}
                    { estadoAppX === 'edit_desde_proyectos' && (
                        (isEditing === "true" || isEditingPagos === "true") 
                            ? <span className="text-red-600 dark:text-red-400">-MODO SOLO LECTURA- Este registro está siendo editado por otro usuario desde Tramitacion Proyectos</span>
                            : ''
                    )}*/}

                    {/*<EditExp />*/}
                    <NuevaEditRED />
                </div>
            </div>

            <div className={`${ estadoAppX === 'previewInformeTecnicoObservaciones' ? "block" : "hidden"}`}>
                <div className="flex flex-col mb-6 p-4 bg-white dark:bg-gray-900 rounded-lg shadow-sm">
                    <button 
                        onClick={() => cambiarEstadoApp('inicial')}
                        className="mb-4 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md self-start"
                    >
                        ← Volver a la tabla
                    </button>
                    <PreviewPDF />
                </div>
            </div>

            {estadoAppX === 'previewViabilidadTécnica' && (<div className={`${ estadoAppX === 'previewViabilidadTécnica' ? "block" : "hidden"}`}>
                <div className="flex flex-col mb-6 p-4 bg-white dark:bg-gray-900 rounded-lg shadow-sm">
                    {deDondeViene === "nuevo" && (
                        <button
                            onClick={() => cambiarEstadoApp('nuevo')}
                            className="mb-4 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md self-start"
                        >
                            ← Volver a Nuevo
                        </button>
                    )}
                    {(deDondeViene === "ediT" || deDondeViene === "edit_desde_pagos" || deDondeViene === "edit_desde_proyectos") && (
                        <button
                            onClick={() => cambiarEstadoApp(deDondeViene)}
                            className="mb-4 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md self-start"
                        >
                            ← Volver a Edición
                        </button>
                    )}
                    <PreviewAndDownloadPDFReport data={formA}/>{/*data={registro}*/}
                </div>
                
            </div> )}

            {/* Estado 'ver' - Resumen de entidad para editor_entidad */}
            {estadoAppX === 'ver' && <ResumenEntidad />}

            {/* Restaurar modal telegram?
                <div className="bg-cyan-500 dark">
                { (user === 'Javier' || user === 'Datos') && (
                    <>
                        <TelegramModal role={role} user={user} userId={userId} socket={socket} isSocketConnected={isSocketConnected}/>
                    </>
                )}
            </div>
            */}


            <div className={`${estadoAppX === 'inicial' 
                ? "bg-white dark:bg-gray-800 pointer-events-none fixed inset-x-0 bottom-0" 
                : "bg-green-300 dark:bg-green-700 fixed inset-x-0 bottom-0"}`}>
                <div className="flex flex-col md:flex-row gap-4 justify-center items-center bg-white dark:bg-gray-800 p-2 border-t border-gray-200 dark:border-gray-700">

                    {(
                        estadoAppX !== 'inicial' &&
                        estadoAppX !== 'previewViabilidadTécnica' &&
                        estadoAppX !== 'previewInformeTecnicoObservaciones' &&
                        estadoAppX !== 'ver'
                    ) && ( //Muestra los botones de guardar solo si no está en estado inicial ni ver // reponer: || !formularioEsValido
                        <>
                            <Button
                                variant="subse"
                                type="submit"
                                onClick={() => handleFinalSave(false)}
                                disabled={role === 'visualizador_municipio' || !formData?.identidad?.codigo_partido || (role === 'editor_municipio' && formData?.identidad?.codigo_partido !== userMunicipio) || (role === 'editor_provincial' && !isEspecial)}
                                title={role === 'visualizador_municipio' ? 'Los usuarios visualizadores no pueden editar' : !formData?.identidad?.codigo_partido ? 'Debe seleccionar un partido' : (role === 'editor_municipio' && formData?.identidad?.codigo_partido !== userMunicipio ? 'Solo puede editar entidades de su municipio' : (role === 'editor_provincial' && !isEspecial ? 'Solo los editores provinciales especiales pueden guardar cambios' : ''))}
                            >
                                {isSavingCont ? "en progreso.." : "GUARDAR y CONTINUAR"}
                            </Button>
                            <Button
                                variant="subse"
                                type="submit"
                                onClick={() => handleFinalSave(true)}
                                disabled={role === 'visualizador_municipio' || !formData?.identidad?.codigo_partido || (role === 'editor_municipio' && formData?.identidad?.codigo_partido !== userMunicipio) || (role === 'editor_provincial' && !isEspecial)}
                                title={role === 'visualizador_municipio' ? 'Los usuarios visualizadores no pueden editar' : !formData?.identidad?.codigo_partido ? 'Debe seleccionar un partido' : (role === 'editor_municipio' && formData?.identidad?.codigo_partido !== userMunicipio ? 'Solo puede editar entidades de su municipio' : (role === 'editor_provincial' && !isEspecial ? 'Solo los editores provinciales especiales pueden guardar cambios' : ''))}
                            >
                                {isSavingExit ? "en progreso.." : "GUARDAR y SALIR"}
                            </Button>
                            <Button variant="subse" type="submit" onClick={toggle} >CANCELAR</Button>
                            {role === 'editor_municipio' && formData?.identidad?.codigo_partido !== userMunicipio && (
                                <span className="text-sm text-red-500 ml-2">
                                    Solo puede editar entidades de su municipio ({userMunicipio})
                                </span>
                            )}                            
                        </>
                    )}
                    
                </div>
            </div>

            <ToastContainer />

            </div>

        </>

    )
}

export const InicioPage = React.memo(InicioPageComponente);
//<Button type="submit" onClick={redirect_Cont} >

//<Button type="submit" onClick={redirect} >